import type { Middleware } from '@reduxjs/toolkit';
import { trackProjectCreated, trackProjectOpened } from '../analytics/bpsEvents';
import { projectSlice } from './ProjectSlice';

export const analyticsMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);

  if (projectSlice.actions.onCreateProject.match(action)) {
    trackProjectCreated();
    trackProjectOpened();
  } else if (projectSlice.actions.onLoadProject.match(action)) {
    trackProjectOpened();
  }

  return result;
};
